export default function StatCard({ title, value, color, icon: Icon, actions, testid }) {
  return (
    <div
      className="rounded-2xl p-4 sm:p-5 relative overflow-hidden shadow-sm min-h-[104px] flex flex-col justify-between"
      style={{ background: color }}
      data-testid={testid}
    >
      <div className="flex items-start justify-between gap-2">
        <span className="text-[13px] sm:text-sm font-bold text-black/75 leading-tight">{title}</span>
        <div className="flex items-center gap-1.5 text-black/70">
          {actions}
          {Icon && <Icon size={20} strokeWidth={2.2} />}
        </div>
      </div>
      <div className="text-xl sm:text-2xl font-extrabold text-black/85 tracking-tight">{value}</div>
    </div>
  );
}
